import React, { useState, useContext, useEffect, useMemo, useCallback } from 'react';
import MaterialTable from 'material-table';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
import tableIcons from "./components/MaterialTableIcons";
import { Form, FormGroup, Button } from 'react-bootstrap';
import Select from '@material-ui/core/Select';
import { useHistory } from 'react-router-dom';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TablePagination from '@material-ui/core/TablePagination';
import axios from 'axios';
import { api_url } from "./authorize";
import { AuthorizeContext } from './RootContext';

const useStyles = makeStyles({
  root: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 48,
    padding: '0 30px',
  },
  title: {
    fontSize: '2em',
  },
});

const theme = createTheme({
  typography: { h6: { fontSize: '1.4em' } },
});

const numberWithCommas = (x) => {
  if (x === null || x === undefined || x === "") return "0.00";
  return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
};

const toCents = (value) => {
  if (value === null || value === undefined || value === "") return 0;

  const cleaned = String(value).replace(/[$,]/g, "").trim();
  const parsed = Number.parseFloat(cleaned);

  if (Number.isNaN(parsed)) return 0;
  return Math.round(parsed * 100);
};

const centsToMoney = (cents) => {
  return Number((cents / 100).toFixed(2));
};

const getRowsPaymentCents = (rows) => {
  if (!Array.isArray(rows)) return 0;
  return rows.reduce((total, row) => total + toCents(row.pay_amt), 0);
};

const ReceivedForm = () => {
  const { token, setAuthBody, setAuthenticated } = useContext(AuthorizeContext);

  const classes = useStyles();
  const history = useHistory();

  const [drop, setDrop] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({
    Date_Paid: "",
    Amount: "",
    Reference: "",
    pay_updates: [],
  });
  const [row_results, add_row_results] = useState(0);
  const [selectedAcctNo, setSelectedAcctNo] = useState("");

  const paymentTotalCents = useMemo(() => getRowsPaymentCents(tableData), [tableData]);
  const paymentTotal = useMemo(() => centsToMoney(paymentTotalCents), [paymentTotalCents]);

  const handleAuthResponse = useCallback((res) => {
    if (res.data.message) {
      alert(res.data.message);
      return true;
    }

    if (res.data.validation) {
      alert(res.data.validation.replace("_", " "));
      return true;
    }

    if (res.data.notLoggedIn) {
      setAuthenticated(false);
      setAuthBody({ role: 'visitor' });
      alert("You have been logged out due to inactivity. Please log in again.");
      return true;
    }

    return false;
  }, [setAuthenticated, setAuthBody]);

  const loadInvoicesForPayee = useCallback(async (acctNo) => {
    if (!acctNo) return;

    setSelectedAcctNo(acctNo);
    setTableData([]);
    add_row_results(0);

    setFormData((prev) => ({
      ...prev,
      Acct_No: acctNo,
      pay_updates: [],
    }));

    try {
      const res = await axios({
        url: `https://${api_url}/api/packing_invoice?lookup=AR_DETAIL&acctid=${encodeURIComponent(acctNo)}`,
        method: 'get',
        headers: {
          'x-access-token': token,
        },
      });

      if (handleAuthResponse(res)) return;

      const invoices = Array.isArray(res.data.Unpaid_invoices)
        ? res.data.Unpaid_invoices
        : [];

      const cleanedInvoices = invoices.map((invoice) => ({
        ...invoice,
        //pay_amt: centsToMoney(toCents(invoice.pay_amt || 0)),
        pay_amt: 0,
      }));

      setTableData(cleanedInvoices);

      setFormData((prev) => ({
        ...prev,
        Customer_Name: res.data.Customer_Name || "",
        Acct_No: res.data.Acct_No || acctNo,
        currency: res.data.currency || "",
        pay_updates: cleanedInvoices,
      }));
    } catch (error) {
      console.error("Failed to load unpaid invoices:", error);
      alert("Failed to load invoices for this payee.");
    }
  }, [token, handleAuthResponse]);

  const SelectPayee = useCallback((event) => {
    const acctNo = event.target.value;

    if (!acctNo) {
      window.location.href = "/ReceivedForm";
      return;
    }

    window.location.href = `/ReceivedForm?acctid=${encodeURIComponent(acctNo)}`;
  }, []);

  const submitPayment = useCallback((event) => {
    if (event && event.preventDefault) event.preventDefault();

    if (!String(formData.Date_Paid || "").trim()) {
      alert("Please enter a payment date");
      return;
    }

    if (!String(formData.Reference || "").trim()) {
      alert("Please enter a reference number");
      return;
    }

    const cleanedPayUpdates = tableData.map((row) => ({
      ...row,
      pay_amt: centsToMoney(toCents(row.pay_amt)),
    }));

    const tableTotalCents = getRowsPaymentCents(cleanedPayUpdates);
    const enteredAmountCents = toCents(formData.Amount);

    if (!tableTotalCents) {
      alert("Please enter a payment amount on at least one invoice");
      return;
    }

    if (enteredAmountCents !== tableTotalCents) {
      alert("The AMT must match the Total payment amount");
      return;
    }

    const paymentData = {
      ...formData,
      Amount: centsToMoney(enteredAmountCents),
      pay_updates: cleanedPayUpdates,
    };

    axios({
      url: `https://${api_url}/api/packing_invoice`,
      method: 'post',
      data: paymentData,
      headers: {
        'x-access-token': token,
      },
    }).then((res) => {
      if (handleAuthResponse(res)) return;

      if (res.data && res.data.success) {
        alert(res.data.success);
      }

      window.location.reload();
      console.log(res.data);
    }).catch((error) => {
      console.error("Failed to submit payment:", error);
      const apiMessage = error.response && error.response.data && error.response.data.message;
      alert(apiMessage || "Failed to submit payment.");
    });
  }, [formData, tableData, token, handleAuthResponse]);

  const onChange = useCallback((option) => {
    const { name, value } = option.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleClose = useCallback(() => {
    history.push('./arpayment');
  }, [history]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios({
          url: `https://${api_url}/api/packing_invoice?lookup=AR`,
          method: 'get',
          headers: {
            'x-access-token': token,
          },
        });

        if (handleAuthResponse(res)) return;

        setLoading(false);
        console.log(res.data);

        const payeeList = Array.isArray(res.data) ? res.data : [];
        setDrop(payeeList);

        const params = new URLSearchParams(window.location.search);
        const acctNoFromUrl = params.get("acctid");

        if (acctNoFromUrl) {
          loadInvoicesForPayee(acctNoFromUrl);
        }
      } catch (error) {
        console.error("Failed to load payees:", error);
        alert("Failed to load payees.");
        setLoading(false);
      }
    };

    fetchData();
  }, [token, handleAuthResponse, loadInvoicesForPayee]);

  const columns = useMemo(() => [
    {
      title: 'Invoice #',
      field: 'Invoice_ID',
      editable: "never",
      cellStyle: { fontSize: '.7em' },
    },
    {
      title: 'Date',
      field: 'Date_Issued',
      editable: "never",
      cellStyle: { fontSize: '.7em' },
    },
    {
      title: 'Currency',
      field: 'currency',
      editable: "never",
      cellStyle: { fontSize: '.7em' },
    },
    {
      title: 'Invoice Amt',
      field: 'Total_AMT',
      editable: "never",
      cellStyle: { fontSize: '.7em' },
      filtering: false,
      render: rowData => (
        <div>
          {numberWithCommas(Number.parseFloat(rowData.Total_AMT || 0).toFixed(2))}
        </div>
      ),
    },
    {
      title: 'Due Amount',
      field: 'Current_AMT',
      editable: "never",
      cellStyle: { fontSize: '.7em' },
      filtering: false,
      render: rowData => (
        <div>
          {numberWithCommas(Number.parseFloat(rowData.Current_AMT || 0).toFixed(2))}
        </div>
      ),
    },
    {
      title: 'Payment Amount',
      field: 'pay_amt',
      editable: 'always',
      type: 'currency',
      initialEditValue: 0,
      cellStyle: { fontSize: '.7em', width: 10 },
      align: 'right',
    },
  ], []);

  const tableOptions = useMemo(() => ({
    sorting: true,
    search: false,
    showSelectAllCheckbox: true,
    showTextRowsSelected: true,
    addRowPosition: "first",
    actionsColumnIndex: -1,
    selection: false,
    searchFieldAlignment: "left",
    searchAutoFocus: false,
    searchFieldVariant: "outlined",
    filtering: false,
    paging: true,
    pageSizeOptions: [2, 5, 10, 15, 77],
    pageSize: 10,
    paginationType: "stepped",
    showFirstLastPageButtons: false,
    paginationPosition: "bottom",
    exportButton: false,
    exportAllData: false,
    exportFileName: "Payment_Summary",
    grouping: false,
    columnsButton: false,
    rowStyle: (data, index) => index % 2 === 0 ? { background: "#f5f5f5" } : null,
    headerStyle: {
      fontSize: '.8em',
      background: "lightgray",
      fontStyle: "italic",
    },
    searchFieldStyle: {
      fontSize: '2rem',
    },
  }), []);

  const editableConfig = useMemo(() => ({
    onRowUpdate: (newData, oldData) =>
      new Promise((resolve) => {
        const currentCents = toCents(newData.Current_AMT);
        const payCents = toCents(newData.pay_amt);

        if (payCents > currentCents) {
          alert('The Payment amount was greater than the Due AMT for Invoice_ID: ' + newData.Invoice_ID);
          resolve();
          return;
        }

        const updatedRows = tableData.map((row) => {
          if (oldData && row.Invoice_ID === oldData.Invoice_ID) {
            return {
              ...newData,
              pay_amt: centsToMoney(payCents),
            };
          }

          return {
            ...row,
            pay_amt: centsToMoney(toCents(row.pay_amt)),
          };
        });

        const rr = centsToMoney(getRowsPaymentCents(updatedRows));

        add_row_results(rr);
        setTableData(updatedRows);
        setFormData((prev) => ({
          ...prev,
          pay_updates: updatedRows,
        }));

        resolve();
      }),

    onBulkUpdate: selectedRows =>
      new Promise((resolve) => {
        console.log(selectedRows);

        const rows = Object.values(selectedRows);
        const too_much = 'The Payment amount was greater than the Due AMT for Invoice_ID: ';
        const editedRows = [];

        rows.forEach((a) => {
          const currentCents = toCents(a.newData.Current_AMT);
          const payCents = toCents(a.newData.pay_amt);
          console.log(a.newData.Current_AMT)
          console.log(a.newData.pay_amt)
          console.log("JUSTIN WAS HERE <---------")
          console.log(a.newData.Current_AMT)

          if (currentCents >= payCents) {
            editedRows.push({
              ...a,
              newData: {
                ...a.newData,
                pay_amt: centsToMoney(payCents),
              },
            });
          } else {
            alert(too_much + a.newData.Invoice_ID);
          }
        });

        const sub = [];

        tableData.forEach((item) => {
          if (!sub.find(thing => thing.Invoice_ID === item.Invoice_ID)) {
            const updatedRow = editedRows.find(sltd => sltd.newData.Invoice_ID === item.Invoice_ID);

            if (updatedRow) {
              sub.push(updatedRow.newData);
            } else {
              sub.push({
                ...item,
                pay_amt: centsToMoney(toCents(item.pay_amt)),
              });
            }
          }
        });

        const rr = centsToMoney(getRowsPaymentCents(sub));

        add_row_results(rr);
        setTableData(sub);

        setFormData((prev) => ({
          ...prev,
          pay_updates: sub,
        }));

        setTimeout(() => {
          resolve();
        }, 500);
      }),
  }), [tableData]);

  return (
    <>
      <Form className="arForm">
        <FormGroup style={{ marginBottom: '5px', marginLeft: '230px' }}>
          <div>
            <div>
              <label>Payee</label>
            </div>

            <div>
              <Select
                native
                value={selectedAcctNo}
                onChange={SelectPayee}
                style={{ fontSize: '2rem' }}
                inputProps={{
                  name: 'Payee',
                }}
                variant="outlined"
                required
              >
                <option value="">Choose Payee</option>

                {drop
                  ? drop.map((option) => (
                    <option
                      key={option.Acct_No}
                      value={option.Acct_No}
                    >
                      {`${option.Acct_No}--${option.Customer_Name}`}
                    </option>
                  ))
                  : null}
              </Select>
            </div>
          </div>
        </FormGroup>

        <FormGroup style={{ marginBottom: '5px', marginLeft: '230px' }}>
          <div>
            <div>
              <label>Date</label>
            </div>

            <div>
              <input
                name="Date_Paid"
                type="date"
                value={formData.Date_Paid || ""}
                onChange={onChange}
                required
              />
            </div>
          </div>
        </FormGroup>

        <FormGroup style={{ marginBottom: '5px', marginLeft: '230px' }}>
          <div>
            <div>
              <label>AMT</label>
            </div>

            <div>
              <input
                name="Amount"
                type="number"
                step="0.01"
                value={formData.Amount || ""}
                onChange={onChange}
                required
              />
            </div>
          </div>
        </FormGroup>

        <FormGroup style={{ marginBottom: '5px', marginLeft: '230px' }}>
          <div>
            <div>
              <label>Reference#</label>
            </div>

            <div>
              <input
                name="Reference"
                type="text"
                value={formData.Reference || ""}
                onChange={onChange}
              />
            </div>
          </div>
        </FormGroup>

        <DialogActions style={{ marginRight: '1000px' }}>
          <Button
            type="button"
            className="btn btn-primary arForm"
            onClick={() => window.location.href = "/ReceivedForm"}
            style={{ fontSize: '2em' }}
          >
            Reset
          </Button>

          <button
            type="button"
            className="btn btn-danger arForm"
            onClick={handleClose}
            style={{ fontSize: '2em' }}
          >
            Close
          </button>
        </DialogActions>
      </Form>

      <ThemeProvider theme={theme}>
        <div className="w-75 mx-auto mt-5">
          <MaterialTable
            title={"Invoices"}
            columns={columns}
            data={tableData}
            icons={tableIcons}
            localization={{
              pagination: {
                labelDisplayedRows: '{from}-{to} of {count}',
              },
              toolbar: {
                nRowsSelected: '{0} row(s) selected',
              },
              header: {
                actions: 'Edit',
              },
              body: {
                emptyDataSourceMessage: loading
                  ? 'Loading...'
                  : 'No records to display',
                filterRow: {
                  filterTooltip: 'Filter',
                },
              },
            }}
            options={tableOptions}
            style={{
              fontSize: '20px',
              width: '80%',
            }}
            editable={editableConfig}
            components={{
              Pagination: (props) => (
                <div>
                  <Grid container style={{ padding: 15, background: '#f5f5f5' }}>
                    <Grid sm={8} align="right" item>
                      <Typography variant="h6">Total</Typography>
                    </Grid>

                    <Grid sm={3} style={{ paddingRight: 60 }} align="center" item>
                      <Typography variant="h6">{paymentTotal.toFixed(2)}</Typography>
                    </Grid>

                    <Grid sm={1}>
                      <Button
                        type="button"
                        className="btn-success"
                        onClick={submitPayment}
                      >
                        Pay
                      </Button>
                    </Grid>
                  </Grid>

                  <TablePagination {...props} />
                </div>
              ),
            }}
          />
        </div>
      </ThemeProvider>
    </>
  );
};

export default ReceivedForm;